module.exports = __webpack_public_path__ + "img/note-2.d896e8a4.svg";